export default __webpack_public_path__ + "static/media/hamburgerMenu.svg";